module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown-navigation"
  }, [(_vm.content.menu) ? _c('cmp-form-field-select', {
    attrs: {
      "items": _vm.content.menu.items
    },
    model: {
      value: (_vm.routePath),
      callback: function($$v) {
        _vm.routePath = $$v
      },
      expression: "routePath"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1896b51e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1896b51e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/cms-plugins/dropdown-navigation/index.vue
// module id = 511
// module chunks = 7